import { render } from "./ButtonDemo.vue?vue&type=template&id=32810b1f"
import script from "./ButtonDemo.vue?vue&type=script&lang=js"
export * from "./ButtonDemo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/amee/iptu-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__